/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_DocumentInputs */

const en_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Document`)
};

const es_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir documento`)
};

const fr_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploader un document`)
};

const de_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument hochladen`)
};

const ja_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメントをアップロード`)
};

const zh_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传文档`)
};

const ar_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفع مستند`)
};

const id_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah Dokumen`)
};

const it_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica Documento`)
};

const ru_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить документ`)
};

const pt_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer upload de Documento`)
};

const ko_upload_document = /** @type {(inputs: Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 업로드`)
};

/**
* | output |
* | --- |
* | "Upload Document" |
*
* @param {Upload_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_document = /** @type {((inputs?: Upload_DocumentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_DocumentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_document(inputs)
	if (locale === "es") return es_upload_document(inputs)
	if (locale === "fr") return fr_upload_document(inputs)
	if (locale === "de") return de_upload_document(inputs)
	if (locale === "ja") return ja_upload_document(inputs)
	if (locale === "zh") return zh_upload_document(inputs)
	if (locale === "ar") return ar_upload_document(inputs)
	if (locale === "id") return id_upload_document(inputs)
	if (locale === "it") return it_upload_document(inputs)
	if (locale === "ru") return ru_upload_document(inputs)
	if (locale === "pt") return pt_upload_document(inputs)
	return ko_upload_document(inputs)
});